import { Component, OnInit, Input } from '@angular/core';
import { Constant } from 'src/app/common/constant/constant';

@Component({
  selector: 'app-ro-estimate-top-template',
  templateUrl: './ro-estimate-top-template.component.html',
  styleUrls: ['./ro-estimate-top-template.component.scss']
})
export class RoEstimateTopTemplateComponent implements OnInit {

  @Input() templateData: any = {};
  public copiedModal: boolean = false;
  public maskEmail: string = Constant.maskEmail;
  public customerEmail: string = '';
  public estimateId: any = 0;
  public paymentMethodEnabledFlag: boolean = localStorage.getItem('paymentMethodEnabled') == '1' ? true : false;

  constructor() { }

  ngOnInit(): void {
    
    console.log(this.templateData)
    let email:any = this.templateData?.roData.businessInfo.email;
    let splitEmail = email.split(this.maskEmail);
    email = (splitEmail.length > 1) ? '' : email;
    this.customerEmail = email;
    let estDataInfo: any = [];
    switch(this.templateData.access) {
      case 'Estimate':
        estDataInfo = this.templateData.roData.estimateInfoDataJsonArr;
        break;
      default:
        estDataInfo = this.templateData.roData.invoiceInfoDataJsonArr;
        break;
    }
    if(estDataInfo && estDataInfo != undefined && estDataInfo.length > 0) {
      this.estimateId = estDataInfo[0].estId;
    }
  }

  copyLink(value){
    navigator.clipboard.writeText(value);
    this.copiedModal = true;
    setTimeout(() => {
      this.copiedModal = false;
    }, 1200);    
  }

  navWebsite(url) {
    window.open(url, url);
  }

}
